var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_15018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9705 11.4414C15.2555 10.4339 13.7755 9.65891 13.7755 8.43016C13.7755 7.39141 14.6292 6.79891 16.1517 6.79891C18.9355 6.79891 21.7955 7.87141 23.7642 8.83766L24.8767 1.97016C23.3155 1.22266 20.1217 0.00390625 15.7067 0.00390625C12.5842 0.00390625 9.98672 0.821406 8.13047 2.34391C6.20047 3.93766 5.19672 6.24391 5.19672 9.02641C5.19672 14.0752 8.28047 16.2264 13.2917 18.0502C16.523 19.2002 17.598 20.0177 17.598 21.2789C17.598 22.5039 16.548 23.2102 14.6555 23.2102C12.3117 23.2102 8.44922 22.0589 5.91797 20.5739L4.79297 27.5177C6.96922 28.7414 10.9817 30.0039 15.143 30.0039C18.4442 30.0039 21.1967 29.2239 23.053 27.7377C25.133 26.1064 26.2092 23.6927 26.2092 20.5727C26.2092 15.4127 23.0542 13.2589 17.9667 11.4414H17.9705Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_15018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.16fb24f56deee86993d2ca6330924c5e.svg";
export { ForwardRef as ReactComponent };